import styled from 'styled-components';

export const ToggleWrapper = styled.div`
    .MuiFormControlLabel-label {
        margin-left: 32px;
    }
`;

export const EmailsInputInfo = styled.div`
    margin-top: 16px;
    margin-bottom: 16px;
`;

export const NotificationsWrapper = styled.div`
    margin-bottom: 24px;
`;
